import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

export type NotifierStatus = 'default' | 'success' | 'error' | 'warn';

export interface NotifierData {
    message: string;
    context?: string;
    list?: Array<any>;
    status?: NotifierStatus;
}

@Component({
    selector: 'app-notifier',
    templateUrl: './notifier.component.html',
    styleUrls: ['./notifier.component.scss']
})
export class NotifierComponent implements OnInit, OnDestroy {

    showDetail = false;

    readonly statusIcons = {
        default: 'notifications',
        success: 'check_circle',
        error: 'error',
        warn: 'warning'
    };

    constructor(@Inject(MAT_SNACK_BAR_DATA) public data: NotifierData,
        public snackBarRef: MatSnackBarRef<NotifierComponent>) { }


    ngOnDestroy(): void {
        this.snackBarRef.dismiss();
    }

    ngOnInit() {
        this.showDetail = !this.showDetail;
    }

    showDetails() {
        this.showDetail = !this.showDetail;
    }

    get status(): NotifierStatus {
        return this.data.status || 'default';
    }

}
